export const MYSTUFF_PROMPT_BOX_ID = 'designs-mystuff-prompt-box';
export const AICHAT_MARKETING_PROMPT_BOX_ID = 'marketing-aichat-prompt-box';